var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.89169 13.014C2.68378 12.7168 2.57227 12.3628 2.57227 12C2.57227 11.6373 2.68378 11.2833 2.89169 10.986C4.23998 9.07717 7.55969 5.14288 12.0006 5.14288C16.4414 5.14288 19.7611 9.07717 21.1094 10.986C21.3173 11.2833 21.4288 11.6373 21.4288 12C21.4288 12.3628 21.3173 12.7168 21.1094 13.014C19.7611 14.9229 16.4414 18.8572 12.0006 18.8572C7.55969 18.8572 4.23998 14.9229 2.89169 13.014Z",
    stroke: "#DEE1E6",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0008 15.4286C13.8944 15.4286 15.4294 13.8935 15.4294 12C15.4294 10.1064 13.8944 8.57141 12.0008 8.57141C10.1073 8.57141 8.57227 10.1064 8.57227 12C8.57227 13.8935 10.1073 15.4286 12.0008 15.4286Z",
    stroke: "#DEE1E6",
    strokeWidth: 2.05714,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.247759812f5bf65e1b63904c4c039c1f.svg";
export { ForwardRef as ReactComponent };